<!--Landing page-->
<ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
  <li class="nav-item"><a class="nav-link active" data-toggle="tab" name="UtilityProcessMaster" href="#divUtilityProcesstab">Process Master</a></li>
  <li class="nav-item"><a class="nav-link" data-toggle="tab" name="UtilityProcessMasterTrans" href="#divUtilityProcessrans">Utility Process Mapping</a></li>
</ul>
<br />
<div class="tab-content">
  <!--UtilityProcess Master-->
  <div class="tab-pane active" id="divUtilityProcesstab">
    <button type="button" id="BtnPopup" (click)="ShowUtilityProcessMaster()" style="display:none">ShowUtilityProcessMaster</button>

    <table #dataTable class="display" style="width:100%"></table>
  </div>
  <!--UtilityProcess Publisher Mapping Trans-->
  <div class="tab-pane" id="divUtilityProcessrans">
    <button type="button" id="Btnpopup" (click)="ShowUtilityProcessMasterTrans()" style="display:none">ShowUtilityProcessPublisherMappingTrans</button>
    <table #dataTablePM class="display" style="width:100%"></table>
  </div>
</div>

<!--Utility Process Master-->
<div class="modal" id="updatetablevalue" [style.display]="showpopupUtilityProcessMaster ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">{{UPMTitle}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="UPMhide()">×</button>
      </div>
      <!--popup body-->
      <div class="modal-body" style="overflow:hidden !important" id="popupbody">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              <label for="Txt_ProcessName">Process name<em>*</em></label>
              <input id="Txt_ProcessName" type="text" class="form-control" maxlength="100" autocomplete="off">
            </div>
            <div class="col-sm-6">
              <label for="Txt_ProcessFlow">Process flow <em>*</em></label>
              <input id="Txt_ProcessFlow" type="text" class="form-control" maxlength="100" autocomplete="off">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <label for="Txt_Remakrs">Remarks</label>
              <textarea id="Txt_Remakrs" class="form-control rounded-0" maxlength="225" autocomplete="off" data-origin="textarea"></textarea>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-3 clsMargin Chk_UPMIsDelete">
            <input type="checkbox" id="Chk_UPMIsDelete" title="Delete Utility Process master" (change)="UPMIsDeleteConfirmation($event)">&nbsp;
            <label>Delete</label>
          </div>
        </div>
      </div>
      <!--popup body end-->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="UPMhide()">Close</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="UpdateUtilityProcessMaster()">{{UPMpopUpButtonText}}</button>
      </div>
    </div>
  </div>
  <!--popup Loader-->
  <div id="LoadingImagePopup">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
  </div>
</div>

<!--Utility Process Publisher Mapping-->
<div class="modal" id="UPPMpopup" [style.display]="showpopupUtilityProcessPublisherMapping ? 'block' : 'none'">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">{{UPPMTitle}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="UPPMhide()">×</button>
      </div>
      <!--popup body-->
      <div class="modal-body" style="overflow:hidden !important" id="popupbody">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <label for="Txt_UtilityConfigName"> Utility config name<em>*</em></label>
                  <input id="Txt_UtilityConfigName" type="text" class="form-control" autocomplete="off">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <label for="ddl_Process">Process <em>*</em></label>
                  <select id="ddl_Process" class="form-control">
                    <option value="0" selected disabled>Select Process</option>
                    <option *ngFor="let item of UtilityProcessMasterList" value={{item.Id}}>
                      {{item.ProcessName}}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-sm-6">
                  <label for="ddl_PublisherType">Publisher type <em>*</em></label>
                  <select id="ddl_PublisherType" class="form-control">
                    <option value="0" selected disabled>Select PublisherType</option>
                    <option *ngFor="let item of ManuflowPublisherType" value={{item.Id}}>
                      {{item.PublisherType}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label for="ddl_ProductType">Product type <em>*</em></label>
                  <select id="ddl_ProductType" class="form-control">
                    <option value="0" selected disabled>Select ProductType</option>
                    <option *ngFor="let item of ManuflowProductType" value={{item.Id}}>
                      {{item.ProductType}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-6">
                  <label for="ddl_Vendor">Vendor</label>
                  <select id="ddl_Vendor" class="form-control">
                    <option value="0" selected disabled>Select Vendor</option>
                    <option *ngFor="let item of VendorList" value={{item.ID}}>
                      {{item.VendorName}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label for="ddl_Journals">Journal</label>
                  <select id="ddl_Journals" class="form-control">
                    <option value="0" disabled>Select Journal</option>
                    <option *ngFor="let item of JournalsList" value={{item.ID}}>
                      {{item.Acronym}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-6">
                  <label for="ddl_ArticleTypes">Article type</label>
                  <select id="ddl_ArticleTypes" class="form-control">
                    <option value="0" disabled>Select ArticleTypes</option>
                    <option *ngFor="let item of ArticleTypes" value={{item.SNo}}>
                      {{item.TypeName}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <label for="Txt_UPPMRemarks">Remarks</label>
                  <textarea id="Txt_UPPMRemarks" class="form-control rounded-0" rows="7" style="resize:none;" autocomplete="off" data-origin="textarea"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-3 clsMargin Chk_UPPMIsDelete">
                <input type="checkbox" id="Chk_UPPMIsDelete" title="Delete Utility Process Publisher Mapping" (change)="UPPMIsDeleteConfirmation($event)">&nbsp;
                <label>Delete</label>
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <!--Table-->
            <div class="row ">
              <div class="col-sm d-flex justify-content-end ">
                <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="ShowUPPMTrans()"><i class="fa fa-plus"></i></button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button type="button" id="btnUPPMTAddUpdate" (click)="ShowUPPMTrans();" style="display:none">Get</button>
                <div class=" form-group tblcolumtans col-md-12 fixTableHead">
                  <table class="table" id="tblUPPMtans" style="width: 100%; border-collapse: collapse;">
                    <thead>
                      <tr>
                        <th>Sequence</th>
                        <th>Display name</th>
                        <th>Utility filename</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!--Table end-->
          </div>
        </div>
      </div>
      <!--popup body end-->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="UPPMhide()">Close</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="UpdateUtilityProcessPubMapping()">{{UPPMpopUpButtonText}}</button>
      </div>
    </div>
  </div>
  <!--popup Loader-->
  <div id="LoadingImagePopup1">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
  </div>
</div>

<!--Utility Process Publisher Mapping Trans-->
<div class="modal" id="UPPMTransPopup" [style.display]="showpopupUPPMTrans ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">{{UPPMTransTitle}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="UPPMTranshide()">×</button>
      </div>
      <!--popup body-->
      <div class="modal-body" style="overflow:hidden !important" id="popupbody">
        <button type="button" id="btnPlFilenamevalidation" (click)="PlFilenamevalidation()" style="display:none">PlFilenamevalidation</button>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-4">
              <label for="ddl_PlFileName">Utility filename<em>*</em></label>
              <select id="ddl_PlFileName" class="form-control" onchange="$('#btnPlFilenamevalidation').trigger('click');">
                <option value="0" disabled>Select Utility fileName</option>
                <option *ngFor="let item of PlFileNameList" value={{item.Pl_FileName}}>
                  {{item.Pl_FileName}}
                </option>
              </select>
            </div>
            <div class="col-sm-4">
              <label for="Txt_DisplayName">Display name <em>*</em></label>
              <input id="Txt_DisplayName" type="text" class="form-control" maxlength="15" autocomplete="off">
            </div>
            <div class="col-sm-4">
              <label for="Txt_PlFilePath">Utility filePath</label>
              <input id="Txt_PlFilePath" type="text" class="form-control" maxlength="50" autocomplete="off">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-4">
              <label for="Txt_ParameterList">Parameters</label>
              <input id="Txt_ParameterList" type="text" class="form-control" maxlength="225" autocomplete="off">
            </div>
            <div class="col-sm-4">
              <label for="Txt_InPath">In path</label>
              <input id="Txt_InPath" type="text" class="form-control" maxlength="225" autocomplete="off">
            </div>
            <div class="col-sm-4">
              <label for="Txt_OutPath">Out path</label>
              <input id="Txt_OutPath" type="text" class="form-control" maxlength="225" autocomplete="off">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-3">
              <label for="Txt_Sequence">Sequence</label>
              <input id="Txt_Sequence" disabled type="number" min="0" class="form-control" autocomplete="off">
            </div>
            <div class="col-sm-3 clsMargin">
              <input type="checkbox" id="Chk_IsUpload">&nbsp;
              <label>Upload</label>
            </div>
            <div class="col-sm-3 clsMargin">
              <input type="checkbox" id="Chk_IsDownload">&nbsp;
              <label>Download</label>
            </div>
            <div class="col-sm-3 clsMargin Chk_UPPMTIsDelete">
              <input type="checkbox" id="Chk_UPPMTIsDelete" title="Delete Utility Process Publisher Mapping Trans" (change)="UPPMTIsDeleteConfirmation($event)">&nbsp;
              <label>Delete</label>
            </div>
          </div>
        </div>
      </div>
      <!--popup body end-->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="UPPMTranshide()">Close</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="AddUpdateUPPMTrans()">{{UPPMTranspopUpButtonText}}</button>
      </div>
    </div>
  </div>
  <!--popup Loader-->
  <div id="LoadingImagePopup2">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
  </div>
</div>

